import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Loading } from 'components/atoms/loading';
import { RoutePaths } from 'constant';
import { useProjectsQuery } from 'queries';
import { logger } from 'services';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CpPreviewWithoutProject: React.FC = () => {
  const { data: projects } = useProjectsQuery();
  const router = useHistory();

  useEffect(() => {
    if (projects && projects.length > 0) {
      const project = projects[0];

      logger.debug('Redirecting to live customer portal');

      const path = RoutePaths.liveCustomerPortal.replaceAll(
        ':projectId',
        project.projectId.toString(),
      );

      router.replace(path);
    }
  }, [projects, router]);

  return (
    <Wrapper>
      <Loading size="large" />
    </Wrapper>
  );
};
